<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import { useApiClient } from "@/api/client";
import StoredDocumentDO = App.Data.StoredDocumentDO;
import { useRouter } from "vue-router";

const router = useRouter();

const headers = [
	{
		title: "Configuration",
		align: "start",
		key: "title",
		sortable: false,
	},
];

const isLoading = ref(true);
const items = ref();

onBeforeMount(() => fetchRecentStoredDocuments());

const fetchRecentStoredDocuments = async () => {
	isLoading.value = true;
	const response = await useApiClient(
		"documents"
	).getRecentStoredDocumentsForUser(4);
	if (response.isOk()) {
		items.value = response.value;
	}
	isLoading.value = false;
};

const openConfiguration = (item: StoredDocumentDO) => {
	router.push({
		name: "explorer.graphWrapper",
		query: {
			"base-document": item?.active_document_uuid,
		},
	});
};
</script>

<template>
	<v-card class="d-flex flex-column">
		<v-card-title class="bg-background" style="height: 48px">
			Recent explorer configurations
		</v-card-title>

		<v-card-text class="px-2 py-0">
			<v-data-table
				density="compact"
				hide-default-header
				hide-default-footer
				:items="items"
				:headers="headers"
				:loading="isLoading"
				items-per-page="4"
				style="background-color: rgba(0, 0, 0, 0)"
			>
				<template #no-data>
					<div class="py-3">
						You don't have any configurations. Click below to create and save
						your first configuration
					</div>
				</template>
				<template v-slot:item.title="{ item }">
					<div
						class="d-flex align-items-center cursor-pointer"
						@click="openConfiguration(item)"
					>
						<div
							class="py-1"
							style="
								text-wrap: nowrap;
								max-width: 250px;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							{{ item.title }}
						</div>
						<v-spacer />
						<div>
							<v-btn
								v-tooltip="`Open dashboard ${item.title}`"
								color="on-surface"
								variant="text"
								density="compact"
								icon
							>
								<v-icon size="15">fa: fal fa-arrow-right</v-icon>
							</v-btn>
						</div>
					</div>
				</template>
			</v-data-table>
			<v-divider opacity="0.25" />
		</v-card-text>

		<v-spacer />

		<div class="d-flex pa-2">
			<v-spacer />
			<v-chip variant="flat" to="/explorer"> Go to explorer </v-chip>
		</div>
	</v-card>
</template>

<style scoped lang="scss">
.table-row:hover {
	background-color: rgba(var(--color-secondary), 0.5);
}
</style>
